<template>
    <div class="playbook-type-list mb-5 mx-2">
		<h1 class="mb-3">Playbook Editor</h1>
    	   <div class="mb-3">
			<div class="card mb-3 table-card">
				<div class="card-header">
					<div class="row">
						<div class="col-lg-6 col-12">
							<h3 class="mt-2">Playbook Templates ({{ filtered_playbook_types.length }})</h3>
						</div>

						<div class="col-lg-6 d-none d-lg-block">
							<div class="d-flex justify-content-end justify-self-end gap-2">
								<div class="position-relative">
									<input 
                                        type="text" 
                                        placeholder="Search by Name..." 
                                        aria-label="Search by Name..." 
                                        v-model="search_key" 
                                        @input="handleFilterSelection" 
                                        autocomplete="one-time-code" 
                                        class="search-box form-control me-1 py-2"
                                    >
									<i class="fa fa-search search-placeholder-icon" v-if="!search_key"></i>
								</div>
								<!-- <button class="btn btn-secondary me-1 py-0 dropdown-toggle dropdown-toggle-no-btn" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
									<img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt="">Filters
								</button>
								<div class="dropdown-menu dropdown-menu-primary p-3">

								</div> -->
								<a class="btn btn-primary float-end" href="/admin/playbook_type/new">
									<i class="fa fas fa-fw fa-plus"></i> Add Playbook Template
								</a>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body p-0">
					<table class="table table-with-pagination mb-0">
						<thead>
							<tr class="table-header-row">
								<th @click="sortByKey('name')" class="d-table-cell">
									<div class="d-flex flex-row">
										Name
										<div class="d-flex flex-column">
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'name' && sort_order === 'asc'}" alt=""
                                            >
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'name' && sort_order === 'des'}" alt=""
                                            >
										</div>
									</div>
								</th>
								<th @click="sortByKey('status')" class="d-table-cell">
									<div class="d-flex flex-row">
										Status
										<div class="d-flex flex-column">
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'status' && sort_order === 'asc'}" alt=""
                                            >
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'status' && sort_order === 'des'}" alt=""
                                            >
										</div>
									</div>
								</th>
								<th class="d-table-cell column-sort-disabled">
									<div class="d-flex flex-row">
										Channels
									</div>
								</th>
								<th @click="sortByKey('asset_types_length')" class="d-table-cell">
									<div class="d-flex flex-row">
										# of Assets
										<div class="d-flex flex-column">
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'asset_types_length' && sort_order === 'asc'}" alt=""
                                            >
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'asset_types_length' && sort_order === 'des'}" alt=""
                                            >
										</div>
									</div>
								</th>
								<th @click="sortByKey('updated_at')" class="d-table-cell">
									<div class="d-flex flex-row">
										Updated At
										<div class="d-flex flex-column">
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-up.svg" 
                                                :class="{'sort-key-active': sort_key === 'updated_at' && sort_order === 'asc'}" alt=""
                                            >
											<img 
                                                class="sort-key" 
                                                src="/img/icons/avid-icons/chevron-down.svg" 
                                                :class="{'sort-key-active': sort_key === 'updated_at' && sort_order === 'des'}" alt=""
                                            >
										</div>
									</div>
								</th>
								<th class="d-table-cell pe-3" width="1">
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(playbook_type, index) in list_shown" :key="`playbook-type-${playbook_type.id}-${index}`">
								<td class="d-table-cell align-start">
									<a :href="`/admin/playbook_type/${playbook_type.id}`">{{ playbook_type.name }}</a>
								</td>
								<td class="d-table-cell">
									<span class="badge" :class="getStatusBadgeClass(playbook_type.status)">
										{{ getStatusDisplayText(playbook_type.status) }}
									</span>
								</td>
								<td class="d-table-cell">
									<span v-html="getIcons(playbook_type.asset_types)"></span>
								</td>
								<td class="d-table-cell">
									<span>{{ playbook_type.asset_types?.length || 0 }}</span>
								</td>
								<td class="d-table-cell">
									{{ datetime(playbook_type.updated_at) }}
								</td>
								<td class="d-table-cell">
									<div class="dropdown">
										<button class="btn btn-none" type="button" :id="`dropdownMenuButton-${playbook_type.id}`" data-bs-toggle="dropdown" aria-expanded="false">
											<i class="fas fa-ellipsis-vertical" data-bs-toggle="tooltip" title="Actions"></i>
										</button>
										<ul class="dropdown-menu" :aria-labelledby="`dropdownMenuButton-${playbook_type.id}`">
											<li>
												<a class="dropdown-item text-danger" href="#" @click.prevent="deletePlaybookType(playbook_type)">
													<img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt="">Delete Template
												</a>
											</li>
										</ul>
									</div>
								</td>
							</tr>
						</tbody>
						<tfoot class="table-border-bottom-0">
							<tr>
								<td colspan="100%" class="py-0">
									<div class="table-pagination">
										<div class="table-pagination--group d-none d-md-flex">
											<div class="position-relative">
												<select 
                                                    class="form-select" 
                                                    v-model="num_per_page" 
                                                    @change="reloadPagination(filtered_playbook_types)"
                                                 aria-label="Num Per Page">
													<option value="5000">ALL</option>
													<option 
                                                        v-for="num in num_per_page_options" 
                                                        :key="`num-${num}`" 
                                                        :value="num"
                                                    >
                                                        {{ num }}
                                                    </option>
												</select>
												<div class="select-display-text">
													Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
												</div>
											</div>
										</div>

										<div class="table-pagination--group d-none d-lg-flex">
											{{ filtered_playbook_types.length === 0 ? '0' : item_interval }} of {{ filtered_playbook_types.length }}
										</div>

										<div class="table-pagination--group">
											<button 
                                                v-if="page_count > 1" 
                                                class="btn btn-secondary btn-icon-only-md me-1" 
                                                @click="moveToPrevPage(filtered_playbook_types)" 
                                                :disabled="page_index === 0"
                                            >
												<img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
											</button>

											<div class="d-flex page-selector" v-if="page_index_array.length <= 3">
												<button 
                                                    v-for="page in page_index_array" 
                                                    :key="`page-${page}`" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    :class="{'current-page': page === (page_index + 1)}" 
                                                    @click="moveToPage(page, filtered_playbook_types)"
                                                >
													{{ page }}
												</button>
											</div>
											<div class="d-flex page-selector" v-else>
												<button 
                                                    v-for="page in page_index_array.slice(0,2)" 
                                                    :key="`page-${page}`" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    :class="{'current-page': page === (page_index + 1)}" 
                                                    @click="moveToPage(page, filtered_playbook_types)"
                                                >
													{{ page }}
												</button>

												<button 
                                                    v-if="page_index > 2" 
                                                    class="btn btn-none btn-icon-only-md text-nowrap" 
                                                    disabled
                                                >
													...
												</button>
												<button 
                                                    v-if="page_index >= 2 && page_index < page_index_array.length -1" 
                                                    class="btn btn-none btn-icon-only-md current-page"
                                                >
													{{ page_index + 1 }}
												</button>

												<button 
                                                    v-if="page_index < page_index_array.length -2" 
                                                    class="btn btn-none btn-icon-only-md text-nowrap" 
                                                    disabled
                                                 aria-hidden="true">
													...
												</button>
												<button 
                                                    :class="{'current-page': page_index === (page_index_array.length -1)}" 
                                                    class="btn btn-none btn-icon-only-md" 
                                                    @click="moveToPage(page_index_array.length, filtered_playbook_types)" 
                                                    :key="`page-${page_index_array.length}`"
                                                >
													{{ page_index_array.length }}
												</button>
											</div>

											<button 
                                                v-if="page_count > 1" 
                                                class="btn btn-secondary btn-icon-only-md ms-1" 
                                                @click="moveToNextPage(filtered_playbook_types)" 
                                                :disabled="page_index === page_count -1"
                                            >
												<img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
											</button>
										</div>
									</div>
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>


		<div v-if="asset_types?.length > 0" class="mt-5">
			<asset-type-list :asset_types="asset_types"></asset-type-list>
		</div>
   </div>
</template>

<script>
import { defineComponent } from 'vue';
import AssetTypeList from './AssetTypeList.vue';
import tablePaginationMixin from '../../../mixins/table_pagination';
import { useNotifications } from '../../../composables/useNotifications';

export default defineComponent({
	name: 'PlaybookTypeList',
	components: {
		AssetTypeList
	},
	props: {
		playbook_types: {
			type: Array,
			default: () => [],
		},
		asset_types: {
			type: Array,
			default: () => [],
		},
	},
	mixins: [tablePaginationMixin],
	data() {
		return {
			filtered_playbook_types: [],
			list_shown: [],
			search_key: '',
			sort_key: 'name',
			sort_order: 'asc',
		};
	},
	beforeMount() {
		this.filtered_playbook_types = [...this.playbook_types];
		this.reloadPagination(this.filtered_playbook_types);
	},
	methods: {
		handleFilterSelection(){
			let filtered_list = [];

			this.playbook_types.forEach(playbook_type => {
				let in_search = this.search_key === '' || playbook_type.name.toLowerCase().includes(this.search_key.toLowerCase());

				if (in_search){
					filtered_list.push(playbook_type);
				}
			});

			this.filtered_playbook_types = filtered_list;
			this.sortData();
			this.reloadPagination(this.filtered_playbook_types);
		},
		getIcons(asset_types){
			if (!asset_types?.length) {
				return '<span>No Asset Attached</span>';
			}
			
			var icon_list = this.getIconsByAssetType(asset_types);
			let iconElements = '';
			icon_list.forEach(icon_class => {
				iconElements += `<img src="/img/icons/avid-icons/${icon_class}.svg" class="asset-type-icon icon mx-1" alt=""/>`;
			});
			return iconElements;
		},
		getIconsByAssetType(asset_types){
			var icon_list = [];

			asset_types.forEach(asset_obj => {
				if (!icon_list.includes(asset_obj.icon_class)){
					icon_list.push(asset_obj.icon_class);
				}
			});
			return icon_list;
		},
		getStatusBadgeClass(status) {
			switch(status) {
				case 'active':
					return 'badge-blue';
				case 'draft':
					return 'badge-secondary';
				default:
					return 'badge-secondary';
			}
		},
		getStatusDisplayText(status) {
			switch(status) {
				case 'active':
					return 'Active';
				case 'draft':
					return 'Draft';
				default:
					return 'Unknown';
			}
		},
		sortByKey(key) {
			if (this.sort_key === key) {
				this.sort_order = (this.sort_order === 'asc') ? 'des' : 'asc';
			} else {
				this.sort_key = key;
				this.sort_order = 'asc';
			}
			this.sortData();
		},
		sortData() {
			if(this.sort_key === 'asset_types_length'){
				if (this.sort_order === 'asc') {
					this.filtered_playbook_types.sort((a, b) => (a.asset_types?.length || 0) - (b.asset_types?.length || 0));
				} else {
					this.filtered_playbook_types.sort((a, b) => (b.asset_types?.length || 0) - (a.asset_types?.length || 0));
				}
			} else if(this.sort_key === 'status'){
				// Custom sorting for status: active first, then draft
				const statusOrder = { 'active': 1, 'draft': 2 };
				if (this.sort_order === 'asc') {
					this.filtered_playbook_types.sort((a, b) => {
						const aOrder = statusOrder[a.status] || 3;
						const bOrder = statusOrder[b.status] || 3;
						return aOrder - bOrder;
					});
				} else {
					this.filtered_playbook_types.sort((a, b) => {
						const aOrder = statusOrder[a.status] || 3;
						const bOrder = statusOrder[b.status] || 3;
						return bOrder - aOrder;
					});
				}
			} else {
				if (this.sort_order === 'asc') {
					this.filtered_playbook_types.sort((a, b) => a[this.sort_key].localeCompare(b[this.sort_key]));
				} else {
					this.filtered_playbook_types.sort((a, b) => b[this.sort_key].localeCompare(a[this.sort_key]));
				}
			}
			this.reloadPagination(this.filtered_playbook_types);
		},
		deletePlaybookType(playbook_type){
			Swal.fire({
				title: "Are you sure you want to delete this playbook type?",
				text: "This playbook type will be removed.",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, delete",
				customClass: {
					popup: 'swal-warning'
				},
			}).then((result) => {
				if (result.isConfirmed) {
					window.axios.delete('/api/playbooks/playbook_type/'+ playbook_type.id);
					this.showNotification({
						text: '<strong>' + playbook_type.name + '</strong> was deleted!'
					});
					for(var i = 0; i < this.filtered_playbook_types.length; i++){
						if(this.filtered_playbook_types[i].id === playbook_type.id){
							this.filtered_playbook_types.splice(i, 1);
							break;
						}
					}

					this.reloadPagination(this.filtered_playbook_types);
				}
			});
		}
	},
});
</script>
